import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchIntegrationRequestEmailCampaigns, fetchIntegrationRequestEmailDraft } from "./api"

export function useIntegrationRequestEmailCampaigns() {
  const getContext = useApiContext()

  return useQuery({
    queryKey: ["integration-request-email-campaigns"],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")

      return fetchIntegrationRequestEmailCampaigns(context)
    },
    staleTime: 1000 * 60 * 10,
  })
}

export function useIntegrationRequestEmailDraft(campaignKey: string, options?: { enabled?: boolean }) {
  const getContext = useApiContext()

  return useQuery({
    queryKey: ["integration-request-email-draft", campaignKey],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")

      return fetchIntegrationRequestEmailDraft(context, campaignKey)
    },
    enabled: options?.enabled ?? true,
    staleTime: Infinity,
    retry: false,
  })
}
